import type {CustomDealProduct} from '../../../types';

import {Checkbox} from '@ds/components';
import promotionIcon from 'assets/images/promotion-center/promotion-icon-primary-color.svg';
import ProductBadge from '../../../components/common/ProductBadge/ProductBadge';
import StockBadge from '../../../components/common/StockBadge/StockBadge';
import {numberFormat} from 'utils/Helper';

type SelectProductsListItemProps = {
  handleProductSelection: (item: CustomDealProduct) => void;
  item: CustomDealProduct;
  selected: boolean;
};

const SelectProductsListItem: React.FC<SelectProductsListItemProps> = ({
  handleProductSelection,
  item,
  selected
}) => {
  const stock = item.stock || 0;

  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 items-center justify-center">
        <Checkbox
          checked={selected}
          onChange={(event) => {
            handleProductSelection({...item, selected: event.target.checked});
          }}
        />
      </div>
      <button
        type="button"
        onClick={() => handleProductSelection({...item, selected: !selected})}
        className="flex w-full flex-col gap-1 border-b border-gray-22 py-2 pe-4 text-start"
      >
        <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
        <div className="flex items-start justify-between">
          <div className="my-2 flex flex-wrap gap-1">
            {item.badges?.map((badge) => (
              <ProductBadge key={badge} value={badge} />
            ))}
          </div>
          <StockBadge stock={stock} status={item.stock_status} />
        </div>
        <div className="flex items-center gap-2">
          {item.vendor_share ? (
            <>
              <span className="relative text-body-xs text-neutral-fg">{numberFormat(item.price)} تومان</span>
              <span className="inline-flex h-5 min-w-8 items-center justify-center rounded-md bg-orange px-1.5 text-body-xs-emphasis text-white">
                {item.vendor_share}%
              </span>
            </>
          ) : (
            <span className="text-body-sm-emphasis text-neutral-fg">
              {numberFormat(item.price)} تومان
            </span>
          )}
          {item.commercial_share ? (
            <span className="inline-flex items-center gap-1 rounded bg-orange-pale px-1.5 py-0.5 text-body-xs-emphasis text-orange">
              <img src={promotionIcon} alt="" aria-hidden />
              کمپین
            </span>
          ) : null}
        </div>
      </button>
    </div>
  );
};

export default SelectProductsListItem;
